module.exports = __webpack_public_path__ + "static/media/undraw_male_avatar_323b.989a66aa.png";